import { listLocations } from "./locations";
import { listPersonTypes } from "./personTypes";
import { availability } from "./availability";
import { listActivities, readActivitiesPriceRanges } from "./activities";
import { listPackages, readPackagesPriceRange } from "./packages";
import { listSupplements, listSupplementsGroups } from "./supplements";
import { reserve as reserveInstance, cancel } from "./instanceReservation";
import { settings } from "./settings";
import { reserveReservation, readReservation } from "./reservation";

export const Api = {
  getTimeSlots: availability,
  locations: {
    list: listLocations,
  },
  personTypes: {
    list: listPersonTypes,
  },
  activities: {
    list: listActivities,
    readPriceRanges: readActivitiesPriceRanges,
  },
  supplements: {
    list: listSupplements,
    listGroups: listSupplementsGroups,
  },
  packages: {
    list: listPackages,
    readPriceRanges: readPackagesPriceRange,
  },
  instanceReservation: {
    reserve: reserveInstance,
    cancel,
  },
  settings,
  reservation: {
    reserve: reserveReservation,
    read: readReservation,
  },
};
